import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "25",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "#fff",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": ".521",
  d: "M12.52 22.136c5.32 0 9.614-4.316 9.614-9.657a9.6 9.6 0 0 0-9.614-9.614m0 19.27a9.646 9.646 0 0 1-9.657-9.656c0-5.32 4.315-9.614 9.657-9.614m0 19.27V2.866m8.34 4.817H4.144m16.768 9.519H4.09M2.915 12.5h19.167"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "#fff",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": ".521",
  d: "M12.512 22.136c2.66 0 4.807-4.316 4.807-9.657 0-5.32-2.147-9.614-4.807-9.614-2.671 0-4.828 4.294-4.828 9.614 0 5.341 2.157 9.657 4.828 9.657"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }